import { IconContent } from '@icons';

export const trashcan: IconContent = {
    sm: '<path fill-rule="evenodd" d="M10 2v1H6V2h4ZM3 4h10v1h-1l-.8 8H4.8L4 5H3V4Zm2.005 1h5.99l-.7 7h-4.59l-.7-7Z" />',
};
